import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	name: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	type: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	administrators: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	location: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyFilterResultMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterResultsAnnouncement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aToZOrder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	zToAOrder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// delete actions message when cleaning up isVisualRefreshEnabled FG
	actions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	name: {
		id: 'directories.boards-v2.main.name',
		defaultMessage: 'Name',
		description: 'Caption for the column heading for displaying the board name',
	},
	type: {
		id: 'directories.boards-v2.main.type',
		defaultMessage: 'Type',
		description: 'Caption for the column heading for displaying the board type',
	},
	administrators: {
		id: 'directories.boards-v2.main.administrators',
		defaultMessage: 'Admin',
		description: "Caption for the column heading for displaying the board's administrators",
	},
	location: {
		id: 'directories.boards-v2.main.location',
		defaultMessage: 'Location',
		description: "Caption for the column heading for displaying the board's location",
	},
	emptyFilterResultMessage: {
		id: 'directories.boards-v2.main.empty-filter-result-message',
		defaultMessage: 'No boards were found that match your search',
		description:
			"Message to be displayed when user tried to filter boards but the filter criteria didn't match any",
	},
	tableAriaLabel: {
		id: 'directories.boards-v2.main.table-aria-label',
		defaultMessage: 'Boards details',
		description:
			'Message to be used as aria-label of boards table. The aria-label is announced by screen readers and helps users who use them understand the purpose of table',
	},
	filterResultsAnnouncement: {
		id: 'directories.boards-v2.main.filter-results-announcement',
		defaultMessage:
			'{itemCount, plural, =0 {No boards were found that match your search} one {{itemCount} board found} other {{itemCount} boards found}}',
		description:
			'Message for screen reader users to announce how many boards were found after filtering',
	},
	aToZOrder: {
		id: 'directories.boards-v2.main.a-to-z-order',
		defaultMessage: 'Sort A to Z',
		description:
			'Ascending order used for the sort button toolip for a column which contains text or names',
	},
	zToAOrder: {
		id: 'directories.boards-v2.main.z-to-a-order',
		defaultMessage: 'Sort Z to A',
		description:
			'Descending order used for the sort button toolip for a column which contains text or names',
	},
	// delete actions message when cleaning up isVisualRefreshEnabled FG
	actions: {
		id: 'directories.boards-v2.main.actions',
		defaultMessage: 'More actions',
		description: "Caption for the column heading for displaying board's more actions",
	},
});
export default messages;
